import React, { Component } from 'react'

class ErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false }
    }

    componentDidCatch(error, errorInfo) {
        // Display fallback UI
        this.setState({ hasError: true })
    }

    render() {
        if (this.state.hasError) {
            return <h5 className='text-center mt-5 mb-5'>There was an error while opening the page.</h5>
        } else {
            return this.props.children
        }
    }
}

export default ErrorBoundary
